



















































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { PermissionCollectionModel } from '@/modules/permission/models/permission-collection.model'
import AdminRoleSearch from '@/modules/role/components/admin/AdminRoleSearch.vue'
import AdminPermissionFuzzySearch from '@/modules/permission/components/admin/AdminPermissionFuzzySearch.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import {
  AdminUpdateUserAccessibilityUseCase
} from '@/modules/user/use-cases/admin/admin-update-user-accessibility.use-case'
import { UpdateUserAccessibilityRequestModel } from '@/modules/user/models/user-request.model'
import { UserResourceInAdminModel } from '@/modules/user/models/user-resource.model'

@Component({
  components: {
    BaseButton,
    AdminPermissionFuzzySearch,
    AdminRoleSearch
  }
})
export default class AdminUserAccessibilityForm extends Vue {
  constructor(
    private readonly useCase: AdminUpdateUserAccessibilityUseCase
  ) {
    super()
  }

  @Prop({ required: true }) allPermissions: PermissionCollectionModel[]
  @Prop({ required: true }) userResource: UserResourceInAdminModel

  permissions = this.userResource.permissions.map(permission => permission.id)

  roles = this.userResource.roles.map(role => role.id)

  defaultRoles = this.roles

  onSubmit() {
    const requestData: UpdateUserAccessibilityRequestModel = {
      roles: this.roles,
      permissions: this.permissions
    }
    this.useCase.execute(this.userResource.id, requestData)
  }
}
